<div class="login-card">
  @if (legalModalOpen) {
  <div class="legal-backdrop" role="dialog" aria-modal="true">
    <div class="legal-dialog">
      <h4 class="mb-2">Documentos legales</h4>
      <p class="text-muted small mb-3">
        Debe aceptar las actualizaciones para continuar.
      </p>
      @for (doc of pendingLegalVersions; track doc.id) {
      <div class="mb-3">
        <strong>{{
          doc.type === "terms_and_conditions"
            ? "Términos y condiciones"
            : "Aviso de privacidad"
        }}</strong>
        <span class="text-muted"> (v{{ doc.version }})</span>
        <ul class="small mt-1 mb-0">
          @for (line of doc.change_summary; track $index) {
          <li>{{ line }}</li>
          }
        </ul>
      </div>
      }
      <div class="d-flex gap-2 justify-content-end">
        <button
          type="button"
          class="btn btn-light btn-sm"
          (click)="closeLegalModal()"
          [disabled]="legalLoading"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          (click)="confirmLegalAcceptance()"
          [disabled]="legalLoading"
        >
          {{ legalLoading ? "…" : "Estoy de acuerdo" }}
        </button>
      </div>
    </div>
  </div>
  }
  <div class="login-main">
    @if (otpStep) {
    <form class="theme-form" (ngSubmit)="submitOtp()">
      <h4 class="text-center">Verifica tu acceso</h4>
      <p>
        Enviamos un código de 6 dígitos a <strong>{{ otpEmail }}</strong>.
        Ingresalo para entrar al Back Office.
      </p>
      <div class="form-group">
        <label class="col-form-label">Código de verificación</label>
        <input
          class="form-control"
          type="text"
          inputmode="numeric"
          maxlength="6"
          [(ngModel)]="otpCode"
          name="otpCode"
          placeholder="000000"
          autocomplete="one-time-code"
        />
        @if (loginError) {
        <div class="login-error">{{ loginError }}</div>
        }
      </div>
      <div class="form-group mb-0">
        <button
          class="btn btn-primary btn-block w-full text-white mt-[24px]"
          type="submit"
          [disabled]="legalLoading"
        >
          {{ legalLoading ? "…" : "Verificar código" }}
        </button>
        <button
          type="button"
          class="btn btn-link w-full mt-2"
          (click)="resendOtp()"
          [disabled]="otpSending || otpCooldownSec > 0"
        >
          {{
            otpSending
              ? "Enviando…"
              : otpCooldownSec > 0
                ? "Reenviar en " + otpCooldownSec + "s"
                : "Reenviar código"
          }}
        </button>
        <button type="button" class="btn btn-link w-full" (click)="backToPassword()">
          Volver
        </button>
      </div>
    </form>
    } @else {
    <form class="theme-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <h4 class="text-center">Iniciar sesión</h4>
      <p>
        Ingrese su correo electrónico y contraseña para acceder al Backoffice.
      </p>
      <div class="form-group">
        <label class="col-form-label">Correo electrónico</label>
        <input
          class="form-control"
          type="email"
          formControlName="email"
          placeholder="test@gmail.com"
          [class.is-invalid]="
            loginForm.get('email')?.invalid && loginForm.get('email')?.touched
          "
        />
        <div
          *ngIf="
            loginForm.get('email')?.invalid && loginForm.get('email')?.touched
          "
          class="invalid-feedback"
        >
          Por favor, ingrese una dirección de correo electrónico válida.
        </div>
      </div>
      <div class="form-group">
        <label class="col-form-label">Contraseña</label>
        <div class="form-input relative">
          <input
            class="form-control"
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            placeholder="*********"
            [class.is-invalid]="
              !!loginError ||
              (loginForm.get('password')?.invalid &&
                loginForm.get('password')?.touched)
            "
          />
          <div class="show-hide" (click)="togglePassword()">
            <span [class.show]="!showPassword"></span>
          </div>
        </div>
        <div
          *ngIf="
            loginForm.get('password')?.invalid &&
            loginForm.get('password')?.touched
          "
          class="invalid-feedback"
        >
          La contraseña es requerida (mínimo 6 caracteres).
        </div>
        @if (loginError) {
        <div class="login-error">{{ loginError }}</div>
        }
      </div>
      <div class="form-group mb-0">
        <div class="form-check flex gap-2 items-center">
          <input
            class="checkbox-primary form-check-input custom-checkbox"
            id="checkbox1"
            type="checkbox"
          />
          <label class="text-muted form-check-label !mb-0" for="checkbox1"
            >Recordar contraseña</label
          >
        </div>
        <div class="text-end">
          <button
            class="btn btn-primary btn-block w-full text-white mt-[24px]"
            type="submit"
            [disabled]="loginForm.invalid || legalLoading"
          >
            {{ legalLoading ? "…" : "Acceder" }}
          </button>
        </div>
      </div>
    </form>
    }

    @if (!otpStep) {
    <div class="social-divider">
      <span>o continuar con</span>
    </div>

    @if (socialError) {
    <div class="alert alert-danger py-2 px-3 small mb-3">{{ socialError }}</div>
    }

    <div class="d-flex flex-column gap-2">
      <button
        type="button"
        class="social-btn social-btn--google"
        (click)="loginWithGoogle()"
        [disabled]="socialLoading"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 48 48">
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.35-8.16 2.35-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          <path fill="none" d="M0 0h48v48H0z"/>
        </svg>
        {{ socialLoading ? 'Conectando…' : 'Continuar con Google' }}
      </button>

      <button
        type="button"
        class="social-btn"
        (click)="loginWithApple()"
        [disabled]="socialLoading"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 814 1000" fill="white">
          <path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-43.4-150.3-104.9C67.1 731.8 27 634 27 540c0-202.9 131.1-310.1 253.4-310.1 68.8 0 126.3 45.3 169.8 45.3 41.7 0 107-47.8 185-47.8zM545.5 44.2C578.2 9.5 601.7-26.5 601.7-75c0-5.8-.5-11.7-1.5-17.2-50.7 1.9-110.7 33.6-147.5 71.1-28.7 30.1-57.4 77-57.4 125.6 0 6.5.9 13 1.4 15 3.3.6 8.8 1.5 14.3 1.5 44.7 0 99.5-29.1 134.5-71.8z"/>
        </svg>
        {{ socialLoading ? 'Conectando…' : 'Continuar con Apple' }}
      </button>
    </div>
    }
  </div>
</div>
